import React, { useState, useEffect } from 'react';
import styles from './Services.module.css';

// Import project images
import project1_3 from '../../images/הבית של יוני וחדווי בבית שמש 1.jpg';
import project2_5 from '../../images/הבית של דור ומוריה באורנית 4.jpg';
import project3_7 from '../../images/הבית של רתם ואורטל בבאר גנים 1.jpg';
import project4_2 from '../../images/הפנטהאוז של שי ומיטל 1.jpg';

// Services data with exact content from document
const services = [
  {
    id: 1,
    number: '01',
    title: 'תכנון ועיצוב דירת קבלן',
    shortTitle: 'דירת קבלן',
    subtitle: 'מהתכנון הראשוני ועד להלבשת הבית',
    image: project2_5,
    quote: 'לכל פונקציה יתוכנן מקום משלה - הבית ישרת אתכם ולא אתם אותו',
    steps: [
      {
        title: 'פגישת היכרות',
        description: 'בכל פרויקט נתחיל קודם כל בפגישת היכרות, פגישה שמטרתה להכיר אתכם :-) להבין מה חשוב לכם, מה ההרגלים והצרכים שלכם. מה מפריע לכם היום בבית הנוכחי ואיך אתם מדמיינים את החיים בבית החדש. נחשוב על החזון העיצובי שלכם ועל שינויים אפשריים בתכנון הקיים.'
      },
      {
        title: 'הכנת סקיצות תכנוניות ובניית קונספט עיצובי',
        description: 'בהתאם לפגישת ההכרות והשאלון שאשלח לכם אתחיל לעבוד על סקיצות אפשריות לחלל הבית/הדירה (מה שנקרא בשפה המקצועית תכנית העמדה). אני אקח את רשימת הצרכים והחלומות שלכם ואטמיע אותם לתוך תכנון ועיצוב הבית שלכם. אכין מס\' סקיצות עד שנקלע למטרה והתכנון יענה על כל הדרישות ותרגישו שזה זה... אדאג כמובן לא להשאיר אף ס"מ לא מנוצל בבית, לכל פונקציה יתוכנן מקום משלה והשאיפה שהבית בסופו של דבר ישרת אתכם ולא אתם אותו.'
      },
      {
        title: 'תכניות ביצוע ושינויים מול חברת שינויי דיירים',
        description: 'וכעת, כשיש כבר תכנית העמדה נתחיל לעבוד מול שינויי דיירים. נפרק את התכנית לגורמים ונכין לקבלן סט תכניות מושלם ומפורט לביצוע: תכנית אדריכלות, תכנית אינסטלציה, תכנית חשמל ותקשורת, תכנית תאורה ותכנית מיזוג והנמכות גבס.'
      },
      {
        title: 'תכניות מטבח ובחירת ריצופים וכלים סניטריים',
        description: 'בהתאם לתכנית העמדת המטבח אכין תכניות נגרות מפורטות לביצוע ונלך יחד לספק המטבחים כדי לקבל הצעת מחיר, במקביל נבחן עבודה מול נגר. בנוסף נצא ליום בחירות של ריצופים וסניטריה עם הספק הנבחר מטעם הקבלן ובסופו של התהליך אכין תכניות ריצופים ופריסות בהתאם לבחירות שנעשו.'
      },
      {
        title: 'שלב הלבשת הבית',
        description: 'לאחר הפסקה בביצוע ולקראת מסירת הדירה אנו ניגשים לתכנן את פרטי הבית לפרטי פרטים. נבצע תכניות נגרות התואמות למרחב, במקביל נצא יחד לימי בחירות משותפים כדי לאבזר את הבית עפ"י החזון העיצובי שתכננו. ושלב אחר שלב נהפוך את הבית מאוסף של קירות לבית מלא באופי! נבחר יחד ריהוט, תאורה, גווני קירות, וילונות, אקססוריס וכל מה שידרש כדי שהבית שלכם יהיה לא פחות ממושלם.'
      }
    ]
  },
  {
    id: 2,
    number: '02',
    title: 'שיפוץ מקיף דירה / בית פרטי',
    shortTitle: 'שיפוץ מקיף',
    subtitle: 'תכנון מחדש והתאמה מושלמת',
    image: project3_7,
    quote: 'זה כמעט השלב הכי מרגש - הקירות שתכננו על הנייר כמעט מוכנים להכיל את החלומות',
    steps: [
      {
        title: 'פגישת היכרות',
        description: 'בכל פרויקט נתחיל קודם כל בפגישת היכרות, פגישה שמטרתה להכיר אתכם :-) להבין מה חשוב לכם, מה ההרגלים והצרכים שלכם. מה מפריע לכם היום בבית הנוכחי ואיך אתם מדמיינים את החיים בבית החדש. נחשוב על החזון העיצובי שלכם ועל אפשרויות שונות לתכנון החלל.'
      },
      {
        title: 'הכנת סקיצות תכנוניות ובניית קונספט עיצובי',
        description: 'בהתאם לפגישת ההכרות והשאלון שאשלח לכם אתחיל לעבוד על סקיצות אפשריות לחלל הבית/הדירה (מה שנקרא בשפה המקצועית תכנית העמדה). אני אקח את רשימת הצרכים והחלומות שלכם ואטמיע אותם לתוך תכנון ועיצוב הבית שלכם. אכין מס\' סקיצות עד שנקלע למטרה והתכנון יענה על כל הדרישות ותרגישו שזה זה... אדאג כמובן לא להשאיר אף ס"מ לא מנוצל בבית, לכל פונקציה יתוכנן מקום משלה והשאיפה שהבית בסופו של דבר ישרת אתכם ולא אתם אותו.'
      },
      {
        title: 'תכניות ביצוע ומפרט כמויות',
        description: 'וכעת, כשיש כבר תכנית העמדה נתחיל נפרק את התכנית לגורמים ונכין סט תכניות מושלם ומפורט לביצוע: תכנית אדריכלות, תכנית אינסטלציה, תכנית חשמל ותקשורת, תכנית תאורה, תכנית מיזוג והנמכות גבס ותכניות אלומיניום. נכין מפרט כמויות המפרט את סוגי העבודות הנדרשות, הכמויות והחומרים. מפרט הכמויות הוא כלי חיוני לניהול מכרז קבלנים, הוא יכול להעריך את עלויות הפרויקט בצורה מדויקת.'
      },
      {
        title: 'בחירת ריצופים, חיפויים וכלים סניטריים',
        description: 'את שלב הגמרים נתחיל מבחירות ריצופים, חיפויים וסניטריה. בחירות אלו יהוו את הבסיס העיצוב לבית. בהתאם לבחירות שנעשה אכין תכניות ריצופים ופריסות כדי לדייק לקבלן איך נרצה שיפרוס ויבצע את הפריטים שנבחרו.'
      },
      {
        title: 'תכניות מטבח',
        description: 'בהתאם לתכנית העמדת המטבח אכין תכניות נגרות מפורטות לביצוע המפרטות את התכנון הפנימי, החומרים, הפרזול ודיטלס נוספים. עם תכניות אלו נוכל לפנות לנגרים וחברות מטבחים על מנת לקבל הצעות מחיר.'
      },
      {
        title: 'תכנון ועיצוב פרטי נגרות',
        description: 'זה כמעט השלב הכי מרגש, הקירות שתכננו על הנייר כמעט מוכנים להכיל את הנישות, הארונות, הספריות, פינות האחסון המיוחדות. וכעת נדייק ונתכנן את פרטי הנגרות לפרטי פרטים, אתמקד בצרכים והדרישות של כל משפחה תוך דגש על אחסון וכמה שיותר ממנו ופרקטיקה כמובן. המטרה היא ליצור פרטי נגרות שהם לא רק יפים אלא גם פונקציונליים ושישרתו אתכם על הצד הטוב ביותר.'
      },
      {
        title: 'שלב הלבשת הבית',
        description: 'נצא יחד לימי בחירות משותפים כדי לאבזר את הבית עפ"י החזון העיצובי שתכננו. ושלב אחר שלב נהפוך את הבית מאוסף של קירות לבית מלא באופי! נבחר יחד ריהוט, תאורה, גווני קירות, וילונות, אקססוריס וכל מה שידרש כדי שהבית שלכם יהיה לא פחות ממושלם.'
      }
    ]
  },
  {
    id: 3,
    number: '03',
    title: 'בניית בית פרטי',
    shortTitle: 'בית פרטי',
    subtitle: 'מאפס ועד המפתח',
    image: project1_3,
    quote: 'שלב אחר שלב נהפוך את הבית מאוסף של קירות לבית מלא באופי',
    steps: [
      {
        title: 'פגישת היכרות',
        description: 'נתחיל קודם כל בפגישת היכרות, פגישה שמטרתה להכיר אתכם :-) להבין מה חשוב לכם, מה ההרגלים והצרכים שלכם. נשוחח על החללים והפונקציות שתרצו לייצר בבית, על הסגנון העיצובי. ארצה לשמוע ואיך אתם מדמיינים את החיים בבית החדש. נחשוב על החזון העיצובי שלכם ועל שינויים אפשריים בתכנון הראשוני.'
      },
      {
        title: 'הכנת סקיצות תכנוניות ובניית קונספט עיצובי',
        description: 'בהתאם לפגישת ההכרות אתחיל לעבוד על חלוקת החללים מחדש, תוך התייחסות למידות הבית, לזרימה הטבעית של החללים, התאורה הטבעית והגינה. אקח את רשימת הצרכים והחלומות שלכם ואטמיע אותם לתוך תכנון ועיצוב הבית שלכם.'
      },
      {
        title: 'תכניות ביצוע ומפרט כמויות',
        description: 'נתחיל נפרק את התכנית לגורמים ונכין סט תכניות מושלם ומפורט לביצוע: תכנית אדריכלות, תכנית אינסטלציה, תכנית חשמל ותקשורת, תכנית תאורה, תכנית מיזוג והנמכות גבס ותכניות אלומיניום. נכין מפרט כמויות המפרט את סוגי העבודות הנדרשות, הכמויות והחומרים. מפרט הכמויות הוא כלי חיוני לניהול מכרז קבלנים, הוא יכול להעריך את עלויות הפרויקט בצורה מדויקת.'
      },
      {
        title: 'בחירת ריצופים, חיפויים וכלים סניטריים',
        description: 'את שלב הגמרים נתחיל מבחירות ריצופים, חיפויים וסניטריה. בחירות אלו יהוו את הבסיס העיצוב לבית. בהתאם לבחירות שנעשה אכין תכניות ריצופים ופריסות כדי לדייק לקבלן איך נרצה שיפרוס ויבצע את הפריטים שנבחרו.'
      },
      {
        title: 'תכניות מטבח',
        description: 'בהתאם לתכנית העמדת המטבח אכין תכניות נגרות מפורטות לביצוע המפרטות את התכנון הפנימי, החומרים, הפרזול ודיטלס נוספים. עם תכניות אלו נוכל לפנות לנגרים וחברות מטבחים על מנת לקבל הצעות מחיר.'
      },
      {
        title: 'תכנון ועיצוב פרטי נגרות',
        description: 'זה כמעט השלב הכי מרגש, הקירות שתכננו על הנייר כמעט מוכנים להכיל את הנישות, הארונות, הספריות, פינות האחסון המיוחדות. וכעת נדייק ונתכנן את פרטי הנגרות לפרטי פרטים, אתמקד בצרכים והדרישות של כל משפחה תוך דגש על אחסון וכמה שיותר ממנו ופרקטיקה כמובן. המטרה היא ליצור פרטי נגרות שהם לא רק יפים אלא גם פונקציונליים ושישרתו אתכם על הצד הטוב ביותר.'
      },
      {
        title: 'שלב הלבשת הבית',
        description: 'נצא יחד לימי בחירות משותפים כדי לאבזר את הבית עפ"י החזון העיצובי שתכננו. ושלב אחר שלב נהפוך את הבית מאוסף של קירות לבית מלא באופי! נבחר יחד ריהוט, תאורה, גווני קירות, וילונות, אקססוריס וכל מה שידרש כדי שהבית שלכם יהיה לא פחות ממושלם.'
      }
    ]
  },
  {
    id: 4,
    number: '04',
    title: 'סטיילינג (הלבשת הבית)',
    shortTitle: 'סטיילינג',
    subtitle: 'רענון ושדרוג ללא שבירת קירות',
    image: project4_2,
    quote: 'שלב אחר שלב נהפוך את הבית מאוסף של קירות לבית מלא באופי',
    steps: [
      {
        title: 'פגישת היכרות',
        description: 'בין אם רכשתם דירת יד שניה או שתרצו לרענן את הדירה הנוכחית שלכם במסלול הלבשה נוכל להגשים לכם את החלום! נתחיל קודם כל בפגישת היכרות, פגישה שמטרתה להכיר אתכם :-) להבין מה חשוב לכם, מה ההרגלים והצרכים שלכם. נשוחח על החללים והפונקציות שתרצו לייצר בבית ועל הסגנון העיצובי.'
      },
      {
        title: 'הכנת תכנית העמדה ובניית קונספט עיצובי',
        description: 'בהתאם לפגישת ההכרות והשאלון שאשלח לכם אכין תכנית חלוקה לחלל עם הפונקציות הנדרשות / פינות האחסון והריהוט. ניצור תכנית העמדה שתהווה בסיס להמשך הבחירות ותכנון הנגרות.'
      },
      {
        title: 'תכניות נגרות',
        description: 'נייצר תכניות נגרות אותם נעביר לספקים להצעות מחיר ומשם לביצוע. אתמקד בצרכים והדרישות של כל משפחה תוך דגש על אחסון וכמה שיותר ממנו ופרקטיקה כמובן. המטרה היא ליצור פרטי נגרות שהם לא רק יפים אלא גם פונקציונליים ושישרתו אתכם על הצד הטוב ביותר.'
      },
      {
        title: 'ימי בחירות',
        description: 'נצא יחד לימי בחירות משותפים כדי לאבזר את הבית עפ"י החזון העיצובי שתכננו. ושלב אחר שלב נהפוך את הבית מאוסף של קירות לבית מלא באופי! נבחר יחד ריהוט, תאורה, גווני קירות, וילונות, אקססוריס וכל מה שידרש כדי שהבית שלכם יהיה לא פחות ממושלם.'
      }
    ]
  }
];

const ServicesScreen = () => {
  const [activeStripe, setActiveStripe] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const handleServiceClick = (service) => {
    setSelectedService(service);
    document.body.style.overflow = 'hidden';
    setTimeout(() => setIsOverlayVisible(true), 50);
  };

  const closeOverlay = () => {
    setIsOverlayVisible(false);
    setTimeout(() => {
      setSelectedService(null);
      document.body.style.overflow = '';
    }, 400);
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeOverlay();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  return (
    <section className={styles.servicesSection}>
      {/* Main Services Container */}
      <div className={styles.servicesContainer}>
        {services.map((service, index) => {
          const isActive = activeStripe === index;
          
          return (
            <div
              key={service.id}
              className={`${styles.serviceStripe} ${isActive ? styles.stripeActive : ''}`}
              onMouseEnter={() => setActiveStripe(index)}
              onMouseLeave={() => setActiveStripe(null)}
              onClick={() => handleServiceClick(service)}
            >
              <img 
                src={service.image} 
                alt={service.title}
                className={styles.stripeImage}
              />
              <div className={styles.stripeOverlay} />
              <div className={styles.stripeNumber}>
                <span>{service.number}</span>
              </div>
              <div className={styles.stripeVerticalText}>
                <span>{service.shortTitle}</span>
              </div>
              <div className={styles.stripeContent}>
                <h3 className={styles.stripeTitle}>{service.title}</h3>
                <p className={styles.stripeSubtitle}>{service.subtitle}</p>
                <button className={styles.stripeButton}>
                  <span>פרטים נוספים</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M7 17L17 7M17 7H7M17 7V17"/>
                  </svg>
                </button>
              </div>
              <div className={styles.stripeAccent} />
            </div>
          );
        })}
      </div>

      {/* LUXURY MODAL */}
      {selectedService && (
        <div 
          className={`${styles.modal} ${isOverlayVisible ? styles.modalVisible : ''}`}
          onClick={closeOverlay}
        >
          <div 
            className={`${styles.modalContent} ${isOverlayVisible ? styles.modalContentVisible : ''}`}
            onClick={e => e.stopPropagation()}
          >
            {/* Close button */}
            <button className={styles.closeButton} onClick={closeOverlay}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>

            {/* Hero Image Section */}
            <div className={styles.modalHero}>
              <img 
                src={selectedService.image} 
                alt={selectedService.title}
                className={styles.modalHeroImage}
              />
              <div className={styles.modalHeroOverlay} />
              
              {/* Number on image */}
              <span className={styles.modalNumber}>{selectedService.number}</span>
              
              {/* Title on image */}
              <div className={styles.modalHeroContent}>
                <h2 className={styles.modalTitle}>{selectedService.title}</h2>
                <p className={styles.modalSubtitle}>{selectedService.subtitle}</p>
              </div>
            </div>

            {/* Content Section */}
            <div className={styles.modalBody}>
              {/* Quote */}
              <div className={styles.quoteSection}>
                <span className={styles.quoteMark}>"</span>
                <p className={styles.quoteText}>{selectedService.quote}</p>
              </div>

              {/* Section Title for Process */}
              <h3 className={styles.processSectionTitle}>שלבי התהליך</h3>

              {/* Steps with title and description */}
              <div className={styles.stepsContainer}>
                {selectedService.steps.map((step, i) => (
                  <div key={i} className={styles.stepCard}>
                    <div className={styles.stepNumber}>
                      <span>{String(i + 1).padStart(2, '0')}</span>
                    </div>
                    <div className={styles.stepContent}>
                      <h4 className={styles.stepTitle}>{step.title}</h4>
                      <p className={styles.stepDescription}>{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className={styles.ctaSection}>
                <p className={styles.ctaText}>מתאים לכם? בואו נדבר</p>
                <a
                  href={`https://wa.me/972543324747?text=${encodeURIComponent(`היי שירלי הגעתי מהדף שלך אשמח לשמוע עוד על ${selectedService.title}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.ctaButton}
                  onClick={closeOverlay}
                >
                  לתיאום שיחה
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ServicesScreen;